/* eslint jsx-a11y/anchor-has-content: 0 */
import React from 'react';

import cn from 'classnames';
import { node, string, shape, bool } from 'prop-types';

import { useNavigate } from 'react-router-dom';

import Button from 'components/Common/Buttons/ButtonV3';

// eslint-disable-next-line no-restricted-imports
import WithLink from './WithLinks';

import s from './Icon.css';

export default function Icon(props) {
  const {
    linkTo,
    href,
    className,
    children,
    variant,
    disableLinkWrapper = false,
    ...restProps
  } = props;
  const navigate = useNavigate();

  if (disableLinkWrapper && linkTo) {
    return (
      <Button
        className={cn(className, s.icon)}
        compactVariant="default"
        icon={children}
        onClick={() => navigate(linkTo)}
        {...restProps}
      />
    );
  }

  return (
    <WithLink variant={variant} linkTo={linkTo} href={href}>
      <Button
        className={cn(className, s.icon)}
        compactVariant="default"
        icon={children}
        {...restProps}
      />
    </WithLink>
  );
}

Icon.propTypes = {
  children: node,
  linkTo: string,
  href: string,
  disableLinkWrapper: bool,
  style: shape({}),
  className: string,
  variant: string,
};

Icon.defaultProps = {
  className: undefined,
  style: {},
  disableLinkWrapper: false,
  children: null,
  linkTo: undefined,
  href: undefined,
  variant: 'appBar',
};
